import tr from '../components/I18N/TranslateHelpers';

export const URL_FOR_RESOURCES = process.env.REACT_APP_URL_FOR_RESOURCES;
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
export const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE;
export const CONVERT_LOCALE_FOR_API = process.env.REACT_APP_CONVERT_LOCALE_FOR_API === "true";
export const BO_URL_FOR_RESOURCES = process.env.REACT_APP_BO_URL_FOR_RESOURCES;
export const SEARCH_URL = process.env.REACT_APP_SEARCH_URL;
export const THEME_IMG = process.env.REACT_APP_THEME_IMAGES;
export const RECAPTCHA_PUBLIC_KEY = process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY;
export const INDIVIDUAL_PROTECTION_CODE = process.env.REACT_APP_INDIVIDUAL_PROTECTION_CODE;
export const SECURITE_BIEN_ETRE_CODE = process.env.REACT_APP_SECURITE_BIEN_ETRE_CODE
export const PROTECTION_CHIMIQUE = process.env.REACT_APP_PROTECTION_CHIMIQUE
export const FIN_STOCK_CODE = process.env.REACT_APP_FIN_STOCK_CODE;

export const paramHeaders = {
  'Access-Control-Allow-Origin' : '*',
  'Content-Type': 'application/json',
  'Access-Control-Allow-Methods' : 'POST, PUT, GET, DELETE, PATCH, OPTIONS',
  'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept',
  'Accept-Patch' : 'application/merge-patch+json'
};
export const paramHeadersPatch = {
  'Access-Control-Allow-Origin' : '*',
  'Content-Type': 'application/merge-patch+json',
  'Access-Control-Allow-Methods' : 'POST, PUT, GET, DELETE, PATCH, OPTIONS',
  'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept',
  'Accept-Patch' : 'application/merge-patch+json',
};

export function getSearchURL(lang: string, keywords: string): string {
  let SEARCH_URL_PARAM = SEARCH_URL === undefined ? "" : SEARCH_URL;

  let searchUrl = SEARCH_URL_PARAM.replace("%search%", tr('search').toLowerCase())
    .replace("%lang%", lang.toLowerCase()).replace("%keywords%", keywords);

  return (searchUrl);
}
